<div class="admin-toolbar">
  <mat-toolbar>
    <div (click)="navigate()" class="header-logo-container">
      <img alt="LandYield Logo" src="../../../assets/LandYield.svg" />
    </div>
    <div class="spacer"></div>
    @if (isAdmin || isReadAdmin) {
      <div
        #dashboard_la="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/admin/dashboard/site']"
        [ngClass]="dashboard_la.isActive ? 'icon-container__active' : 'icon-container__inactive'"
        class="admin menu-link"
        data-cy="app-header-sites"
        routerLinkActive>
        <fa-icon [icon]="['fas', 'table-columns']"></fa-icon>
        Sites
      </div>
      <div
        #dashboards_la="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: false }"
        (menuClosed)="menuClosed()" (menuOpened)="menuOpened('manageDashboardsMenu')"
        [matMenuTriggerFor]="manageDashboardsMenu"
        [ngClass]="{
                'icon-container__active': dashboards_la.isActive,
                'icon-container__inactive': !dashboards_la.isActive,
                'menu-open': currentMenuOpen == 'manageDashboardsMenu'
              }"
        class="admin menu-link"
        data-cy="app-header-dashboards"
        routerLinkActive>
        <fa-icon [icon]="['fas', 'gauge']"></fa-icon>
        Dashboards
        <mat-menu #manageDashboardsMenu="matMenu">
          <button [routerLink]="['/admin/dashboard/checklist']" mat-menu-item data-cy="app-header-checklist-dashboard">
            Checklist
          </button>
          <button [routerLink]="['/admin/dashboard/enrollment-group']" mat-menu-item data-cy="app-header-eg-dashboard">
            Enrollment Groups
          </button>
          <button [routerLink]="['/admin/dashboard/payment']" mat-menu-item data-cy="app-header-payment-dashboard">
            Payments
          </button>
          <button [routerLink]="['/admin/dashboard/stats']" mat-menu-item data-cy="app-header-stats-dashboard">
            Stats
          </button>
        </mat-menu>
      </div>
      <mat-menu #manageModelMenu="matMenu">
        <button [routerLink]="['/admin/manage/project']" mat-menu-item data-cy="app-header-manage-info-projects">
          ACR Projects
        </button>
        <button [routerLink]="['/admin/manage/enrollment-group']" mat-menu-item
                data-cy="app-header-manage-info-enrollment-groups">
          Enrollment Groups
        </button>
        <button [routerLink]="['/admin/manage/faq']" mat-menu-item>
          FAQs
        </button>
        <button [routerLink]="['/admin/manage/program']" mat-menu-item data-cy="app-header-manage-info-programs">
          Programs
        </button>
        <button [routerLink]="['/admin/manage/region']" mat-menu-item data-cy="app-header-manage-info-regions">
          Regions
        </button>
      </mat-menu>
      <mat-menu #manageTemplateMenu="matMenu">
        <button
          [routerLink]="['/admin/manage/components']"
          mat-menu-item
          data-cy="app-header-admin-component-content">
          Component Content
        </button>
        <button
          [routerLink]="['/admin/manage/docusign']"
          mat-menu-item
          data-cy="app-header-admin-docusign">
          Docusign Templates
        </button>
        <button
          [routerLink]="['/admin/manage/email/template']"
          mat-menu-item
          data-cy="app-header-admin-emails">
          Email Templates
        </button>
        <button
          [routerLink]="['/admin/manage/legal']"
          mat-menu-item
          data-cy="app-header-admin-legal-pages">
          Legal Pages
        </button>
        <button
          [routerLink]="['/admin/manage/report-config']"
          mat-menu-item
          data-cy="app-header-admin-report-config">
          Reporting Config
        </button>
      </mat-menu>
      <mat-menu #manageInfoMenu="matMenu">
        <button [routerLink]="['/admin/manage/app-config']" mat-menu-item
                data-cy="app-header-manage-info-app-config">
          App Config
        </button>
        <button [routerLink]="['/admin/manage/county']" mat-menu-item data-cy="app-header-manage-info-counties">
          Counties
        </button>
        <button [matMenuTriggerFor]="manageModelMenu" mat-menu-item>Data Models</button>
        @if (isSuperAdmin) {
          <button [matMenuTriggerFor]="manageTemplateMenu" mat-menu-item>Templates</button>
          <button
            [routerLink]="['/admin/manage/utilities']"
            mat-menu-item
            data-cy="app-header-admin-utilities">
            Utilities
          </button>
        }
      </mat-menu>
      @if (isAdmin || isReadAdmin) {
        <div
          [routerLinkActiveOptions]="{ exact: false }"
          [ngClass]="{
                'icon-container__active': isManageInfoActive(),
                'icon-container__inactive': !isManageInfoActive(),
                'menu-open': currentMenuOpen == 'manageInfoMenu'
              }"
          class="admin menu-link"
          data-cy="app-header-manage-info"
          (menuClosed)="menuClosed()" (menuOpened)="menuOpened('manageInfoMenu')" [matMenuTriggerFor]="manageInfoMenu"
          routerLinkActive>
          <fa-icon [icon]="['fas', 'pen-to-square']"></fa-icon>
          Manage Info
        </div>
      }

      <div
        #permissions_la="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [ngClass]="{
                'icon-container__active': permissions_la.isActive,
                'icon-container__inactive': !permissions_la.isActive,
                'menu-open': currentMenuOpen == 'userMenu'
              }"
        class="admin menu-link"
        routerLinkActive
        (menuClosed)="menuClosed()" (menuOpened)="menuOpened('userMenu')" [matMenuTriggerFor]="userMenu"
        data-cy="app-header-manage-users">
        <span
          [matBadgeHidden]="adminFailedVerificationUsersCount === 0"
          class="admin-manage-users-badge"
          [matBadge]="adminFailedVerificationUsersCount"
          matBadgeColor="warn"
          data-cy="admin-manage-users-badge"></span>
        <fa-icon [icon]="['fas', 'shield-halved']"></fa-icon>
        Users
        <mat-menu #userMenu="matMenu">
          <span
            [matBadgeHidden]="adminFailedVerificationUsersCount === 0"
            matBadge="{{ adminFailedVerificationUsersCount }}"
            matBadgeColor="warn"
            class="user-permissions-badge"></span>
          <button [routerLink]="['/admin/permissions']" data-cy="user-permissions" mat-menu-item>
            User Permissions
          </button>
          <span class="drop-down-mat">
            <button [routerLink]="['/admin/user-activity']" mat-menu-item>User Activity</button>
          </span>
        </mat-menu>
      </div>

      <div
        #account_la="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [ngClass]="{
                'icon-container__active': account_la.isActive,
                'icon-container__inactive': !account_la.isActive,
                'menu-open': currentMenuOpen == 'accountMenu'
              }"
        (menuClosed)="menuClosed()"
        (menuOpened)="menuOpened('accountMenu')"
        [matMenuTriggerFor]="accountMenu"
        class="admin menu-link"
        routerLinkActive>
        <fa-icon [icon]="['fas', 'circle-user']"></fa-icon>
        Account
        <mat-menu #accountMenu="matMenu">
          <button [queryParams]="{ mode: authModeEnum.changePassword }" [routerLink]="['/auth']" mat-menu-item>
            Change Password
          </button>
          <button (click)="logout()" class="logout" mat-menu-item>Log Out</button>
        </mat-menu>
      </div>
      <div
        class="admin mobile-menu menu-link"
        [matMenuTriggerFor]="mobileMenu"
        (menuClosed)="menuClosed()"
        (menuOpened)="menuOpened('mobileMenu')"
        [ngClass]="currentMenuOpen == 'mobileMenu' ? 'menu-open': ''">
        <fa-icon [icon]="['fas', 'bars']"></fa-icon>
        Menu
        <mat-menu #mobileMenu="matMenu">
          <button [routerLink]="'/admin/dashboard/site'" mat-menu-item>Sites</button>
          <button [matMenuTriggerFor]="manageDashboardsMenu" mat-menu-item>Dashboards</button>
          @if (isAdmin) {
            <button [matMenuTriggerFor]="manageInfoMenu" mat-menu-item>Info</button>
          }
          <button [matMenuTriggerFor]="userMenu" mat-menu-item>Users</button>
          <button [matMenuTriggerFor]="accountMenu" mat-menu-item>Account</button>
        </mat-menu>
      </div>
    } @else {
      @if (currentUser?.landowners.length > 0) {
        <div class="delegate-name">
          <div class="avatar">
            {{ actAsUser.getDisplayName({ initials: true }) }}
          </div>
          <div class="delegate-name-text">
            Viewing
            {{
              actAsUser.id === currentUser.id
                ? 'your personal account'
                : 'the account of ' + actAsUser.getDisplayName({})
            }}
          </div>
          <a data-cy="change-account" routerLink="/account/dashboard">&lt;Change&gt;</a>
        </div>
      }
      <div class="spacer"></div>

      @if (loggedIn) {
        <div
          #dashboard_la="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          class="menu-link"
          [ngClass]="dashboard_la.isActive ? 'icon-container__active' : 'icon-container__inactive'"
          [routerLink]="'/account/dashboard'"
          routerLinkActive>
          <fa-icon [icon]="['far', 'tree']"></fa-icon>
          Dashboard
        </div>
        <div
          class="menu-link icon-container__inactive"
          (click)="goToHelp()">
          <fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
          Help
        </div>
        <div
          #account_la="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          [ngClass]="{
                'icon-container__active': account_la.isActive,
                'icon-container__inactive': !account_la.isActive,
                'menu-open': currentMenuOpen == 'accountMenu'
              }"
          (menuClosed)="menuClosed()"
          (menuOpened)="menuOpened('accountMenu')"
          [matMenuTriggerFor]="accountMenu"
          class="menu-link account-menu icon-container__inactive"
          data-cy="app-header-landowner-account"
          routerLinkActive>
            <span
              class="landowner-notification-badge"
              [matBadgeHidden]="landOwnerAccountNotificationBadgeCount <= 0 || currentMenuOpen"
              matBadge="{{ landOwnerAccountNotificationBadgeCount }}"
              matBadgeColor="warn"></span>
          <fa-icon [icon]="['fas', 'circle-user']"></fa-icon>
          Account
          <mat-menu #accountMenu="matMenu">
              <span
                [matBadgeHidden]="landOwnerAccountNotificationBadgeCount <= 0"
                matBadge="{{ landOwnerAccountNotificationBadgeCount }}"
                matBadgeColor="warn"
                class="drop-down-mat">
                <button
                  [routerLink]="['/account/profile']"
                  data-cy="app-header-landowner-account-profile"
                  mat-menu-item>
                  Profile
                </button>
              </span>
            <span class="drop-down-mat">
                <button [routerLink]="['/account/profile/activity']" mat-menu-item>Activity</button>
              </span>
            <button (click)="logout()" class="logout" mat-menu-item>Log Out</button>
          </mat-menu>
        </div>
        <div
          class="mobile-menu menu-link"
          [matMenuTriggerFor]="mobileMenu"
          (menuClosed)="menuClosed()"
          (menuOpened)="menuOpened('mobileMenu')"
          [ngClass]="currentMenuOpen == 'mobileMenu' ? 'menu-open': ''">
          <fa-icon [icon]="['fas', 'bars']"></fa-icon>
          Menu
          <mat-menu #mobileMenu="matMenu">
            <button [routerLink]="'/account/dashboard'" mat-menu-item>Dashboard</button>
            <button [routerLink]="['/account/profile']" mat-menu-item>Profile</button>
            <button [routerLink]="['/account/profile/activity']" mat-menu-item>Activity</button>
            <button (click)="goToHelp()" mat-menu-item>Help</button>
            <button (click)="logout()" class="logout" mat-menu-item>Log Out</button>
          </mat-menu>
        </div>
      }
      @if (!loggedIn) {
        <div class="logged-out-link" (click)="goToLogin()">
          LOG IN
        </div>
      }
    }
    @if (showInfoMessage) {
      <div class="banner">
        <div class="infoMessage">
          {{ this.infoMessage }}
        </div>
        <div (click)="closeInfoMessage()" class="close-icon-container">
          <fa-icon [icon]="['far', 'xmark']" class="white"></fa-icon>
        </div>
      </div>
    }
  </mat-toolbar>
</div>
